const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};

// The container writes window.__ENV__ at start-up (public/env-config.js); local runs fall back to the .env build values.
export const getEnv = (key) => (key in runtimeEnv ? runtimeEnv[key] : process.env[key]);
